import React from 'react'
import styles from './OkedCard.module.scss';
import { Flex, Typography } from "antd"
import { useTranslation } from 'react-i18next';
import { ArrowRight16Regular } from '@fluentui/react-icons';

const OkedCard = ({ id, name, count, section }) => {

  const { t } = useTranslation();
  return (
    <Flex className={styles.card} vertical justify='flex-start' align='flex-start'>
      <Flex className={styles.cardHeader} align='center' justify='space-between'>
        <Typography.Text className={styles.section}>{section}</Typography.Text>
        {
          count > 0 && <Typography.Text className={styles.count}>{count} {t('requirement_count')}</Typography.Text>
        }
      </Flex>
      <Typography.Paragraph className={styles.name}>{name}</Typography.Paragraph>
      <Typography.Link className={styles.link} href={`/mandatory-requirement?okedId=${id}`}>{t('view')} <ArrowRight16Regular className={styles.icon} /></Typography.Link>
    </Flex>
  )
}

export default OkedCard